const styles = `:host{margin:var(--goto-spacing-01)var(--goto-spacing-04);display:flex}`;export default styles;